module.exports = __webpack_public_path__ + "img/monitoring.78bd6c71.svg";